import styles from './diameter-filter.module.scss';
import dropdownListStyles from '../fixcenter-components/dropdown-list/DropdownList.module.scss';
import { IFeatureDiameterDto } from './interfaces/feature-diameter-dto.interface';
import { useEffect, useState } from 'react';
import { useBetween } from 'use-between';
import { ProductFiltersUseBetween } from './use-between/product-filters-use-between';
import { Utils } from '../../shared/constants/utilities.constants';
import DiameterFilterSlider from './sliders/diameter-filter-slider';
import DiameterCheckboxDropdown from './dropdow-list/diameter-checkbox-dropdown';
import { getDiameterList } from './dropdow-list/diameter-checkbox.service';
import { NpsToDn } from '../../shared/constants/pipe-diameter-conversion.constants';
import { getRangeFilter } from './product-filters.service';

export interface IDiameterFilterInput {
    diameterFilter: IFeatureDiameterDto;
    clear?: number;
}

const DiameterFilter: React.FC<IDiameterFilterInput> = ({ diameterFilter, clear }) => {
    const [isDnOpen, setDnIsOpen] = useState<boolean>(false);
    const [isNpsOpen, setNpsIsOpen] = useState<boolean>(false);
    const [isMmOpen, setMmIsOpen] = useState<boolean>(false);
    const { setSelectedNpsAndDnDiameter } = useBetween(ProductFiltersUseBetween);
    const { setDiameterMin } = useBetween(ProductFiltersUseBetween);
    const { setDiameterMax } = useBetween(ProductFiltersUseBetween);
    const { setFeaturesFilters } = useBetween(ProductFiltersUseBetween);
    const { diameterRangeFromTo, setDiameterRangeFromTo } = useBetween(ProductFiltersUseBetween);
    const { currentFeatureId, setCurrentFeatureId } = useBetween(ProductFiltersUseBetween);
    const { diameterList, setDiameterList } = useBetween(ProductFiltersUseBetween);
    const diameterListCopy = getDiameterList();

    const handleDnDropdownClick = () => {
        setDnIsOpen(!isDnOpen);
    };

    const handleNpsDropdownClick = () => {
        setNpsIsOpen(!isNpsOpen);
    };

    const handleMmDropdownClick = () => {
        setMmIsOpen(!isMmOpen);
    };

    const init = () => {
        setCurrentFeatureId(diameterFilter.mm.id);
        setDiameterList(diameterListCopy);
        setSelectedNpsAndDnDiameter(Utils.clone(diameterListCopy));
        setDiameterMin(NpsToDn._1_8.value);
        setDiameterMax(diameterFilter.mm.maxValue);
        setDiameterRangeFromTo([NpsToDn._1_8.value, diameterFilter.mm.maxValue]);
    };

    const handleRangeChange = () => {
        setFeaturesFilters((prevFilters) => {
            return getRangeFilter(
                currentFeatureId as string,
                diameterRangeFromTo[0].toString(),
                diameterRangeFromTo[1].toString(),
                prevFilters
            );
        });
    };

    useEffect(() => {
        handleRangeChange();
    }, [diameterRangeFromTo, currentFeatureId]);

    useEffect(() => {
        if (clear !== undefined && clear > 0) {
            init();
        }
    }, [clear]);

    useEffect(() => {
        init();
    }, []);

    return (
        <div className={styles.container}>
            <div className={dropdownListStyles.dropdownContainer}>
                <div
                    className={`${dropdownListStyles.dropdownButton} ${isMmOpen ? dropdownListStyles.dropdownButtonOpen : ''}`}
                    onClick={handleMmDropdownClick}
                >
                    {diameterFilter.mm.labelInEnglish}
                </div>
                <div
                    className={`${dropdownListStyles.dropdownContent} ${isMmOpen ? dropdownListStyles.dropdownContentOpen : ''}`}
                >
                    <div className={dropdownListStyles.dropdownRow}>
                        <DiameterFilterSlider></DiameterFilterSlider>
                    </div>
                </div>
            </div>
            <div className={dropdownListStyles.dropdownContainer}>
                <div
                    className={`${dropdownListStyles.dropdownButton} ${isDnOpen ? dropdownListStyles.dropdownButtonOpen : ''}`}
                    onClick={handleDnDropdownClick}
                >
                    {diameterFilter.dn.labelInEnglish}
                </div>
                <div
                    className={`${dropdownListStyles.dropdownContent} ${isDnOpen ? dropdownListStyles.dropdownContentOpen : ''}`}
                >
                    <div className={dropdownListStyles.dropdownRow}>
                        <DiameterCheckboxDropdown data={diameterList} isFromDn={true}></DiameterCheckboxDropdown>
                    </div>
                </div>
            </div>
            <div className={dropdownListStyles.dropdownContainer}>
                <div
                    className={`${dropdownListStyles.dropdownButton} ${isNpsOpen ? dropdownListStyles.dropdownButtonOpen : ''}`}
                    onClick={handleNpsDropdownClick}
                >
                    {diameterFilter.nps.labelInEnglish}
                </div>
                <div
                    className={`${dropdownListStyles.dropdownContent} ${isNpsOpen ? dropdownListStyles.dropdownContentOpen : ''}`}
                >
                    <div className={dropdownListStyles.dropdownRow}>
                        <DiameterCheckboxDropdown data={diameterList} isFromDn={false}></DiameterCheckboxDropdown>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DiameterFilter;
